export default __webpack_public_path__ + "static/media/fa6-solid_layer-group.fc99e516.svg";